import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "padding-auth-contents" }
const _hoisted_2 = { class: "card-outlined pt-2 px-4 pb-4" }
const _hoisted_3 = { class: "text-center text-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_back_icon = _resolveComponent("base-back-icon")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!

  return (_openBlock(), _createBlock(_component_layouts_auth_width, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_base_back_icon, { class: "mb-2" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.appName) + " " + _toDisplayString(_ctx.t('terms.title')), 1),
          _cache[0] || (_cache[0] = _createElementVNode("div", null, [
            _createElementVNode("br"),
            _createTextVNode("第1条（総則） "),
            _createElementVNode("br"),
            _createTextVNode("本利用規約はウイニングクルー株式会社（以下「当社」）と当社が提供する「メンタルノイズカウンセラー山根洋士の会員サイト」を利用する者との間の基本的な事項を規定します。 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("第2条（定義） "),
            _createElementVNode("br"),
            _createTextVNode("「本サービス」とは、当社が提供する「メンタルノイズカウンセラー山根洋士の会員サイト」およびこれに付随・関連する全てのサービスをいいます。「利用者」とは、本サービスを利用する個人(法人)をいいます。 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("第3条（適用範囲） "),
            _createElementVNode("br"),
            _createTextVNode("1. 本サービスを利用する者は、本利用規約に同意したものとみなします。 "),
            _createElementVNode("br"),
            _createTextVNode("2. 本利用規約は、本サービスの利用に関し、当社および利用者に対して適用されます。 "),
            _createElementVNode("br"),
            _createTextVNode("3. 当社が本サービスに個別規定や追加規定を掲載する場合、それらは本利用規約の一部を構成するものとし、個別規定または追加規定が本利用規約と抵触する場合には、個別規定または追加規定が優先するものとします。 "),
            _createElementVNode("br"),
            _createTextVNode("4. 本利用規約は、利用者の事前の承諾を得ることなく変更でき、利用者はこれを承諾するものとします。変更後の利用規約は、特段の定めがない限り、変更日より適用されるものとします。ただし、利用者に大きな影響を与える場合には、あらかじめ合理的な事前告知期間を設けるものとします。 "),
            _createElementVNode("br"),
            _createTextVNode("5. 本サービスからリンクされた他のサイトについては、そのサイトの利用規約等に同意のうえ、それに従ってご利用ください。 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("第4条（遵守事項） "),
            _createElementVNode("br"),
            _createTextVNode("1. 当社のサービスのご利用に際しては以下に定める行為（それらを誘発する行為や準備行為も含みます）を禁止いたします。 "),
            _createElementVNode("br"),
            _createTextVNode("① 法令に違反する行為 "),
            _createElementVNode("br"),
            _createTextVNode("② 当社による本サービスの提供を妨害する行為 "),
            _createElementVNode("br"),
            _createTextVNode("③ 当社および本サービスの評価を落とす行為 "),
            _createElementVNode("br"),
            _createTextVNode("④ 他の利用者に対する本サービス以外の営業行為または勧誘行為 "),
            _createElementVNode("br"),
            _createTextVNode("⑤ 他の利用者に対する迷惑行為または名誉毀損行為 "),
            _createElementVNode("br"),
            _createTextVNode("⑥ 本サービスが提供するデータを第三者へ開示、無断転用または再販・再利用する行為 "),
            _createElementVNode("br"),
            _createTextVNode("⑦ 本サービス提供の目的とは異なる目的で利用する行為 "),
            _createElementVNode("br"),
            _createTextVNode("⑧ 他の利用者のID、パスワードを使用して本サービスを利用する行為 "),
            _createElementVNode("br"),
            _createTextVNode("⑨ 手段のいかんを問わず他人からIDやパスワードを入手したり、他人にIDやパスワードを開示したり提供したりする行為 "),
            _createElementVNode("br"),
            _createTextVNode("⑩ 本サービスに関連して、反社会的勢力に直接・間接に利益を提供する行為 "),
            _createElementVNode("br"),
            _createTextVNode("2. 他の利用者において前項の禁止行為を行っていることを発見した場合は、当社までご連絡ください。 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("第5条（サービスの利用停止、ID削除） "),
            _createElementVNode("br"),
            _createTextVNode("当社は、本サービスを適正に運営するために、以下の場合にはあらかじめ通知することなく、データやコンテンツを削除したり、本サービスの全部または一部の利用をお断りしたり、利用者のIDを削除したりするといった措置を講じることができるものとします。 "),
            _createElementVNode("br"),
            _createTextVNode("① 利用者が本利用規約に定められている事項に違反した場合 "),
            _createElementVNode("br"),
            _createTextVNode("② IDが反社会的勢力またはその構成員や関係者によって登録または使用された場合、もしくはそのおそれがあると当社が判断した場合 "),
            _createElementVNode("br"),
            _createTextVNode("③ その他、利用者との信頼関係が失われた場合など、当社と利用者との契約関係の維持が困難であると当社が判断した場合 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("第6条（免責） "),
            _createElementVNode("br"),
            _createTextVNode("1. 本サービスは公表されているデータを基に作成しておりますが、その正確性、相当性、完全性などに対し当社は保証いたしません。 "),
            _createElementVNode("br"),
            _createTextVNode("2. 当社は、利用者間のやりとり、または、利用者間で発生したトラブルについては一切の責任を負いません。 "),
            _createElementVNode("br"),
            _createTextVNode("3. 本サービスに示された表現や再現性には個人差があり、必ずしも利益や効果を保証したものではございません。 "),
            _createElementVNode("br"),
            _createTextVNode("4. 天災地変、その他（通信トラブルなど）の不可抗力により、情報の全部または一部の提供の遅延または提供の不能を生じた場合には、当社はその責を負わないものとします。 "),
            _createElementVNode("br"),
            _createTextVNode("5. 当社は、通信回線やコンピュータ等の障害によるシステムの中断もしくは遅滞、データの消失またはデータへの不正アクセス等により生じた損害または不利益、その他本サービスに関連して利用者または第三者に生じた損害または不利益について、一切責任を負わないものとします。 "),
            _createElementVNode("br"),
            _createTextVNode("6. 当社の故意または重大なる過失に基づく債務不履行の場合を除き、その請求原因の如何を問わず利用者の現実の損害、逸失利益その他の間接損害の賠償の責めにつき当社は一切の責任を負いません。なお、利用者との本利用規約に基づく本サービスのご利用に関する契約が消費者契約法に定める消費者契約に該当する場合、上記の免責は適用されないものとし、当社は、当社の故意・重過失に起因する場合を除き、通常生じうる損害の範囲内で、かつ、当社が当該利用者より受領した利用料を上限として損害賠償責任を負うものとします。 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("第7条（損害賠償） "),
            _createElementVNode("br"),
            _createTextVNode("利用者が本利用規約に違反する行為または不正もしくは違法な行為によって当社に損害を与えた場合、当社は当該会員に対して蒙った一切の損害（訴訟費用および合理的範囲内の弁護士費用を含む。）について、賠償を求めることができるものとします。 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("第8条（クーリングオフ） "),
            _createElementVNode("br"),
            _createTextVNode("本サービスの利用につきクーリングオフ制度は適用されません。 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("第9条（知的財産権） "),
            _createElementVNode("br"),
            _createTextVNode("本サービスに表示され、あるいは本サービスから取得できる全てのデータ、テキスト、情報およびその他の資料（以下「コンテンツ」）に関する著作権、商標権等の全ての権利（以下「知的財産権」）は、当社あるいは表示された会社の財産であり、著作権法等の知的財産権に関する法律等により保護されています。以下において利用者が当社に開示したコンテンツについて、当社は、利用者へ通知することなく、本サービスの提供または本サービスの広告、宣伝を目的として、全部または一部を自由に利用できるものとします。 "),
            _createElementVNode("br"),
            _createTextVNode("・当社サイト "),
            _createElementVNode("br"),
            _createTextVNode("・当社主催のセミナーやアンケート "),
            _createElementVNode("br"),
            _createTextVNode("・当社への問い合わせやメッセージ "),
            _createElementVNode("br"),
            _createTextVNode("・その他上記に類する媒体 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("第10条（主催者による撮影） "),
            _createElementVNode("br"),
            _createTextVNode("本サービスの提供の様子につきましては映像収録を行います。その際に、参加される利用者の様子（利用者の肖像を含みます）や発言が収録されることがあります。収録された映像がプライバシーを配慮した上、商品化や広告などWEBを含む各媒体で使用される可能性がございますので、予めご了承ください。なお、当該使用につきましては利用者に対しいかなる対価も発生しませんので、併せてご了承ください。 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("第11条（退会） "),
            _createElementVNode("br"),
            _createTextVNode("退会希望の際は運営事務局へご連絡下さい。確認次第、利用停止の手続きを行います。 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("第12条（準拠法） "),
            _createElementVNode("br"),
            _createTextVNode("本利用規約およびこれに関する一切の法律関係については、日本国法を準拠法とし、本利用規約は、日本国法に従って解釈されるものとします。 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("第13条（合意管轄） "),
            _createElementVNode("br"),
            _createTextVNode("本サービスに関連して、当社と利用者との間で問題が生じた場合、両者は誠意を持って協議するものとし、協議しても解決しない場合には東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。 "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode("2021年7月13日 改定 ")
          ], -1))
        ])
      ])
    ]),
    _: 1
  }))
}